import React from 'react';

const PageNotFound = () => (
  <div className="vf-page-not-found">
    <div className="vf-page-not-found__title">
      {
        // Alternative is to escape the quotes with &quot; which is ugly and unreadable.
        // eslint-disable-next-line react/jsx-curly-brace-presence
        "Oops! You've hit a dead end."
      }
    </div>
    <img alt="404 Not Found" className="vf-page-not-found__image" src="/assets/images/404.svg" />
    <div className="vf-page-not-found__subtitle">
      {
        // Alternative is to escape the quotes with &quot; which is ugly and unreadable.
        // eslint-disable-next-line react/jsx-curly-brace-presence
        "If you're sure that you have the correct URL, then you may not have access to this page."
      }
    </div>
  </div>
);

export default PageNotFound;
